import * as React from 'react'
import { Box } from '@mui/material'
// KpiResults removed — using KPIWidgetResult instead
import KPIWidgetResult from '../../../../components/widgets/KPIWidgetResult'
import DateRangeFilterCard from '@/components/common/DateRangeFilterCard'
import { formatReadingsDate, getDefaultRange } from '@/utils/consumerReadingsDateRanges'
import { debugLog } from '@/utils/debugLog'

export type DateRange = { from: Date | null; to: Date | null }

type KPI = {
  label: string
  value: string | number
  sublabel?: string
}

type Props = {
  range?: DateRange
  onRangeChange?: (r: DateRange) => void
  onSearch?: (from?: string, to?: string) => void
  kpis?: KPI[]
  disabled?: boolean
  loading?: boolean
  totalConsumption?: number
  avgConsumption?: number
}



export default function HourlyFilter({
  range: rangeProp,
  onRangeChange,
  onSearch,
  disabled,
  loading,
  totalConsumption,
  avgConsumption,
}: Props) {
  const getDefaultRangeForFilter = (): DateRange => getDefaultRange(3, 0)
  const [innerRange, setInnerRange] =
    React.useState<DateRange>(getDefaultRangeForFilter())

  // Results now come from props instead of local state

  const isControlled = rangeProp !== undefined
  const currRange: DateRange = isControlled
    ? (rangeProp as DateRange)
    : innerRange

  const applyRange = React.useCallback(
    (next: DateRange) => {
      onRangeChange?.(next)
      if (!isControlled) setInnerRange(next)
    },
    [onRangeChange, isControlled]
  )

  const { from, to } = currRange

  const formatDateForApi = (d: Date | null) => {
    if (!d) return undefined
    return formatReadingsDate(d)
  }

  const handleSearch = () => {
    debugLog('[HourlyFilter] Search clicked! from:', formatDateForApi(from), 'to:', formatDateForApi(to))
    if (onSearch && from && to && from <= to) {
      onSearch(formatDateForApi(from), formatDateForApi(to))
    } else {
      console.warn('[HourlyFilter] onSearch callback is not defined!')
    }
  }
  // Initial search is now handled by the parent component
  return (
    <Box
      dir="rtl"
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, ml: '10px' }}
    >
      <DateRangeFilterCard
        range={currRange}
        onRangeChange={applyRange}
        onSearch={() => handleSearch()}
        loading={loading}
        disabled={disabled}
        compact
      />

      {(totalConsumption !== undefined || avgConsumption !== undefined) && (
        <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row' }}>
          <KPIWidgetResult
            title="סך כל הצריכה"
            value={totalConsumption ?? 0}
            dateRangeText={from && to ? `${String(from.getDate()).padStart(2, '0')}/${String(from.getMonth() + 1).padStart(2, '0')} - ${String(to.getDate()).padStart(2, '0')}/${String(to.getMonth() + 1).padStart(2, '0')}` : undefined}
          />
          <KPIWidgetResult
            title="ממוצע צריכה שעתית"
            value={avgConsumption ?? 0}
            dateRangeText={from && to ? `${String(from.getDate()).padStart(2, '0')}/${String(from.getMonth() + 1).padStart(2, '0')} - ${String(to.getDate()).padStart(2, '0')}/${String(to.getMonth() + 1).padStart(2, '0')}` : undefined}
          />
        </Box>
      )}
    </Box>
  )
}
